'use strict';

var scrollToElement = require('./scrollToElement.js');
var autosize = require('autosize'); // http://www.jacklmoore.com/autosize/

var IS_WAITING_CLASS_NAME = 'isWaiting';

/**
 * @class
 */
var Forms = {};

/**
 * @public
 */
Forms.init = function() {
	// Setup fields
	Forms._setupFields();

	// Watch for form submissions
	document.addEventListener('submit', Forms._onSubmit.bind(this, 'standard'), false);

	var $ = window.jQuery;
	document.addEventListener('jsfAjaxEvent', function(event) {
		var data = event.detail;
		var fireType = data.fireType;
		if (fireType === 'begin') {
			Forms._onSubmit('a4j', {request: data});
			$(document).triggerHandler('a4jSubmit', {request: data}); // TODO Legacy.
		} else if (fireType === 'success') {
			Forms._onSubmitComplete('a4j', {request: data});
			$(document).triggerHandler('a4jComplete', {request: data}); // TODO Legacy.
		} else if (fireType === 'error') {
			Forms._onSubmitError('a4j', {request: data});
			$(document).triggerHandler('a4jError', {request: data}); // TODO Legacy.
		}
		$(event.target).trigger('jsfAjax' + fireType.charAt(0).toUpperCase() + fireType.substring(1), data);
	});

	// Scroll to first message if there is one.
	Forms.scrollToFirstMessage();
};


/**
 * @private
 */
Forms._setupTextareaAutosize = function() {
	var isSetupKey = "Forms__setupTextareaAutosize_isSetup";

	var onBlur = function(textarea, event) {
		if (event.target === textarea && textarea.value.trim().length === 0) {
			autosize.update(textarea);
		}
	};
	var textareas = document.querySelectorAll('textarea');

	for (var x=0; x < textareas.length; x++) {
		var field = textareas[x];
		if (!field.dataset[isSetupKey]) {
			autosize(field);
			var onBlur_bound = onBlur.bind(this, field);
			field.addEventListener('blur', onBlur_bound);
			field.addEventListener('transitionend', onBlur_bound);
			field.dataset[isSetupKey] = true;
		}
	}
};


/**
 * @private
 */
Forms._setupFields = function() {
	Forms._setupTextareaAutosize();
	Forms._setupFileInputs();
	
	var isSetupKey = "Forms__setupFields_isSetup";

	var onMouseEnter = function(area, field, event) { area.classList.add('hasHover'); };
	var onMouseLeave = function(area, field, event) { area.classList.remove('hasHover'); };
	var onFocus	= function(area, field, event) { area.classList.add('hasFocus'); };
	var onBlur	= function(area, field, event) { area.classList.remove('hasFocus'); };
	var onChange = function(area, field, event){
		if (field.value.trim().length !== 0) {
			area.classList.add('hasValue');
		} else {
			area.classList.remove('hasValue');
		}
	};

	var areas = document.querySelectorAll('.fieldArea');
	for (var x=0; x < areas.length; x++) {
		var area = areas[x];
		var fields = area.querySelectorAll('input, textarea, select');
		for (var i=0; i < fields.length; i++) {
			var field = fields[i];
			if (!field.dataset[isSetupKey]) {
				field.addEventListener('mouseenter', onMouseEnter.bind(this, area, field));
				field.addEventListener('mouseleave', onMouseLeave.bind(this, area, field));
				field.addEventListener('focus', onFocus.bind(this, area, field));
				field.addEventListener('blur', onBlur.bind(this, area, field));
				field.addEventListener('change', onChange.bind(this, area, field));
				onChange(area, field);
				field.dataset[isSetupKey] = true;
			}
		}
	}
};

/**
 * @private
 */
Forms._setupFileInputs = function() {
	var isSetupKey = "Forms__setupFileInputs_isSetup";

	var fileInputsAreas = document.querySelectorAll('.htmlInputFileUpload');
	for (var x=0; x < fileInputsAreas.length; x++) {
		var area = fileInputsAreas[x];
		if (!area.dataset[isSetupKey]) {
			var input = area.querySelector('input'),
				label = area.querySelector('label'),
				labelVal = label.innerHTML;
			input.addEventListener('change', function(e) {
				var fileName = '';
				if (this.files && this.files.length > 1) {
					fileName = this.files.length + ' files selected';
				} else {
					fileName = e.target.value.split('\\').pop();
				}

				if (fileName) {
					label.innerHTML = fileName;
				} else {
					label.innerHTML = labelVal;
				}
			});
			area.dataset[isSetupKey] = true;
		}
	}
};


/**
 * @private
 */
Forms._onSubmit = function(eventType, data) {
	// Find form submitted
	var formElem = null;
	if (eventType === 'a4j' && data.request !== undefined && data.request.source.form !== undefined) {
		formElem = data.request.source.form;
	} else if (data.target !== undefined) {
		formElem = data.target;
	}
	
	// Pause the submitted form
	if (formElem !== null) {
		/* Commented out because I'd rather allow a submission than not. (Michael, 2018-10-21)
		if (Forms.isFormPaused(formElem)) {
			if (data.preventDefault !== undefined) {
				data.preventDefault();
			} else if (eventType === 'a4j' && data.request !== undefined && data.request.abort !== undefined) {
				data.request.abort();
			}
		} else {
		*/
			Forms.pauseForm(formElem);
		// }
	}
};

/**
 * @private
 */
Forms._onSubmitComplete = function(eventType, data) {
	console.log(data);
	if (eventType === 'a4j' && data.request !== undefined && data.request.source.form !== undefined) {
		Forms._setupFields();
		var docElement = document.getElementById(data.request.source.id);
		if (docElement === null && data.request.source.form !== null) {
			docElement = document.getElementById(data.request.source.form.id);
		}
		if (docElement !== null) {
			docElement = docElement.form;
		}
		if (docElement !== null && docElement !== undefined) {
			Forms.unpauseForm(docElement);
		}
		Forms.scrollToFirstMessage();
	}
};

/**
 * @private
 */
Forms._onSubmitError = function(eventType, data) {
	console.log(data);
	if (eventType === 'a4j' && data.request !== undefined && data.request.form !== undefined) {
		Forms._setupFields();
		var docElement = document.getElementById(data.request.source.id);
		if (docElement === null && data.request.source.form !== null) {
			docElement = document.getElementById(data.request.source.form.id);
		}
		if (docElement !== null) {
			docElement = docElement.form;
		}
		if (docElement !== null) {
			Forms.unpauseForm(docElement);
		}
		Forms.scrollToFirstMessage();
	}
};


/**
 * @public
 */
Forms.pauseForm = function(formElem) {
	formElem.classList.add(IS_WAITING_CLASS_NAME);
};
/**
 * @public
 */
Forms.unpauseForm = function(formElem) {
	formElem.classList.remove(IS_WAITING_CLASS_NAME);
};

/**
 * @public
 */
Forms.isFormPaused = function(formElem) {
	return formElem.classList.contains(IS_WAITING_CLASS_NAME);
};


/**
 * @public
 */
Forms.scrollToFirstMessage = function() {
	var wasScrolledTo = "Forms_scrollToFirstMessage_wasScrolledTo"; // Used for ajax so we don't keep scrolling to messages (ajax calls can happen over and over; so once the message area appears we set a dataset on it, and if the ajax call replaces the messages we then rescroll since the data is no longer present)

	// Find first '.messages' or '.message'
	var scrollToElem,
		firstMessage = document.querySelector('.messages'),
		containerMatchQuery = 'form';
	
	if (firstMessage === null) {
		firstMessage = document.querySelector('.message');
		containerMatchQuery = '.fieldArea';
	}
	
	if (firstMessage === null) {
		firstMessage = document.querySelector('.formSection__outcomeMessage');
		containerMatchQuery = 'div';
	}

	
	if (firstMessage !== null) {
		if (firstMessage.dataset[wasScrolledTo]) {
			return;
		}
		firstMessage.dataset[wasScrolledTo] = true;

		// Find the containing 'form' or '.fieldArea', if there is one.
		scrollToElem = firstMessage;
		var curElem = firstMessage
		while(curElem = curElem.parentNode) {
			if (curElem.matches === undefined) {
				break;
			}
			if (curElem.matches(containerMatchQuery)) {
				scrollToElem = curElem;
				break;
			}
		}
		
		scrollToElement(scrollToElem);
	}
};


module.exports = Forms;

